import { Textarea as UiTextarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'

import { textareaVariants } from '../../configs/textarea.config'

import type { ComponentProps } from 'react'

export function Textarea({ className, ...props }: ComponentProps<typeof UiTextarea>) {
  return <UiTextarea {...props} className={cn(textareaVariants(), className)} />
}
